/* Cronduit premium scroll motion
   - Scroll progress bar at top
   - Hero parallax (sets --scroll-y CSS var)
   - Reveal-on-scroll (.in-view-animate, .stagger-children)
*/
(function () {
  if (typeof window === 'undefined') return;

  // ---------- 1. Hero parallax (rAF-throttled) ----------
  // Progress bar is handled by cronduit-premium.js (#cp-prog) — no duplicate needed.
  var heroEls = document.querySelectorAll('.cronduit-hero__bg, .cronduit-hero__content, [data-parallax]');
  var ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var y = window.scrollY || window.pageYOffset;
        // Hero parallax — only when hero is still visible
        if (y < window.innerHeight * 1.2) {
          heroEls.forEach(function (el) {
            el.style.setProperty('--scroll-y', y);
          });
        }
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ---------- 3. Reveal-on-scroll ----------
  if (!('IntersectionObserver' in window)) return;

  // Auto-flag direct children of every .shopify-section as in-view-animate
  // (skipped if author already added the class)
  document.querySelectorAll('.shopify-section').forEach(function (section) {
    Array.prototype.forEach.call(section.children, function (child) {
      if (!child.classList.contains('in-view-animate') &&
          !child.classList.contains('stagger-children') &&
          !child.classList.contains('cronduit-hero') &&
          !child.classList.contains('cronduit-secnav') &&
          !child.classList.contains('cronduit-header')) {
        child.classList.add('in-view-animate');
      }
    });
  });

  // Auto-tag known grids for stagger reveal
  document.querySelectorAll(
    '.cronduit-features__grid, .cronduit-fc__grid, .cronduit-collection__grid, .readout'
  ).forEach(function (g) {
    g.classList.add('stagger-children');
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  // ---------- 4. Sync reveal for above-the-fold (prevents first-paint flash) ----------
  function revealVisibleNow() {
    var vh = window.innerHeight;
    document.querySelectorAll('.in-view-animate, .stagger-children').forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) {
        el.classList.add('is-visible');
      }
    });
  }

  revealVisibleNow();

  // Re-run after fonts settle so layout-shift cases don't flash
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(revealVisibleNow);
  }

  // Still observe everything for off-screen scroll-in
  document.querySelectorAll('.in-view-animate, .stagger-children').forEach(function (el) {
    if (!el.classList.contains('is-visible')) io.observe(el);
  });

  // Fallback scroll listeners — body may be the scroll container when
  // overflow-x:hidden is set, which prevents IO from firing. These
  // ensure sections reveal even when IO callbacks are skipped.
  window.addEventListener('scroll', revealVisibleNow, { passive: true });
  document.body.addEventListener('scroll', revealVisibleNow, { passive: true });

  // ---------- 5. Section-nav active-pill highlighting ----------
  var secnav = document.querySelector('[data-cronduit-secnav]');
  if (secnav) {
    var pills = Array.prototype.slice.call(secnav.querySelectorAll('[data-secnav-target]'));
    var targets = pills.map(function (p) {
      var id = p.getAttribute('data-secnav-target');
      return { pill: p, id: id, el: document.getElementById(id) };
    }).filter(function (t) { return t.el; });

    if (targets.length) {
      var navIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var match = targets.find(function (t) { return t.el === entry.target; });
          if (!match) return;
          if (entry.isIntersecting && entry.intersectionRatio > 0.25) {
            pills.forEach(function (p) { p.classList.remove('is-active'); });
            match.pill.classList.add('is-active');
          }
        });
      }, { threshold: [0.25, 0.5, 0.75], rootMargin: '-80px 0px -40% 0px' });
      targets.forEach(function (t) { navIo.observe(t.el); });
    }

    // Hide the secnav while hero is in view (give hero clean focus)
    var hero = document.querySelector('.cronduit-hero');
    if (hero) {
      var heroIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.4) {
            secnav.classList.add('is-hidden');
          } else {
            secnav.classList.remove('is-hidden');
          }
        });
      }, { threshold: [0.0, 0.4, 0.8] });
      heroIo.observe(hero);
    }
  }
})();
